import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, FormGroup, Label, Form } from "reactstrap";
import { CheckBoxSelection, Inject, MultiSelectComponent } from '@syncfusion/ej2-react-dropdowns';
import { FaTrashAlt } from 'react-icons/fa';
import { makeGetCall } from '../../../../../action/tenantAction';
import { GetWorkorderTechnician, GetWorkOrderBuildingsList } from '../../../../../action/workorderAction';

class WOReportFilter extends Component {
    async componentWillMount(){
        const l_Technician = this.props.GetWorkorderTechnician();
        const l_Building = this.props.GetWorkOrderBuildingsList();
        const l_Tenant = this.props.makeGetCall();
        await Promise.all([l_Technician, l_Building, l_Tenant]);
        if(this.props.IsEdit){
            let preferredfields = this.props.getWorkorderPreferences;
           // var label = this.props.getLabels;
            var selectedStatusId = [], selectedAssignedToId = [], selectedBuildingId = [], selectedTenantId = [], selectedProblemId = [];
            var selectedStatus = [], selectedAssignedTo = [], selectedBuilding = [], selectedTenant = [], selectedProblem = [];
            var lFilters = this.props.SavedData;
            var l_IsSingleBuildingSelected = false;
            if (lFilters.Status !== null) {
                var status = (preferredfields !== "" && preferredfields !== undefined) ? preferredfields.filter(x => x.field === "Status" && x.display === true) : "";
                if (status.length > 0 && status[0].value.length > 0) {
                    lFilters.Status.forEach(el => {
                        var Data = status[0].value.filter(ele => ele.key === el.statusID)[0];
                        selectedStatus.push({ "id": el.statusID, "value": Data !== undefined ? Data.value : "" });
                        selectedStatusId.push(el.statusID);
                    });
                }
            }
            if (lFilters.AssignedTo !== null) {
                if (this.props.getTechnicianList !== undefined && this.props.getTechnicianList !== null && this.props.getTechnicianList.length) {
                    lFilters.AssignedTo.forEach(el => {
                        var Data1 = this.props.getTechnicianList.filter(ele => ele.technicianID === el.assignedUserID)[0];
                        selectedAssignedTo.push({ "id": el.assignedUserID, "value": Data1 !== undefined ? Data1.name : "" });
                        selectedAssignedToId.push(el.assignedUserID);
                    });
                }
            }
            if (lFilters.Building !== null) {
                if (this.props.getWorkOrderBuildings !== undefined && this.props.getWorkOrderBuildings !== null && this.props.getWorkOrderBuildings.length) {
                    lFilters.Building.forEach(el => {
                        var Data2 = this.props.getWorkOrderBuildings.filter(ele => ele.id === el.buildingID)[0];
                        if(Data2 !== undefined && !Data2.isDeleted){
                            selectedBuilding.push({ "id": el.buildingID, "value": Data2 !== undefined ? Data2.name : "" });
                            selectedBuildingId.push(el.buildingID);
                        }
                    });
                    l_IsSingleBuildingSelected = (lFilters.Building.length === 1 && selectedBuildingId.length === 0) ? true : false; 
                }
            }
            if (lFilters.Tenant !== null) {
                if (this.props.getTenantList !== undefined && this.props.getTenantList !== null && this.props.getTenantList.length) {
                    lFilters.Tenant.forEach(el => {
                        var Data3 = this.props.getTenantList.filter(ele => ele.tenantId === el.tenantID)[0];
                        selectedTenant.push({ "id": el.tenantID, "value": Data3 !== undefined ? Data3.tenantName : "", "buildings": Data3 !== undefined ? Data3.buildings : [] });
                        selectedTenantId.push(el.tenantID);
                    });
                }
            }
            if (lFilters.Problem !== null) {
                var problem = (preferredfields !== "" && preferredfields !== undefined) ? preferredfields.filter(x => x.field === "Problem" && x.display === true) : "";
                if (problem.length > 0 && problem[0].value.length > 0) {
                    lFilters.Problem.forEach(el => {
                        var Data4 = problem[0].value.filter(ele => ele.key === el.problemID)[0];
                        selectedProblem.push({ "id": el.problemID, "value": Data4 !== undefined ? Data4.value : "" });
                        selectedProblemId.push(el.problemID);
                    });
                }
            }
            this.setState({
                SelectedStatus: selectedStatusId,
                SelectedStatusList: selectedStatus,
                SelectedAssignedTo: selectedAssignedToId,
                SelectedAssignedToList: selectedAssignedTo,
                SelectedBuilding: selectedBuildingId,
                SelectedBuildingList: selectedBuilding,
                SelectedTenant: selectedTenantId,
                SelectedTenantList: selectedTenant,
                SelectedProblem: selectedProblemId,
                SelectedProblemList: selectedProblem,
                IsSingleBuildingDeleted: l_IsSingleBuildingSelected
            });
        }
    }

    constructor(props) {
        super(props);
        this.state = {
            SelectedStatusList : [],
            SelectedStatus : [],
            SelectedAssignedToList : [],
            SelectedAssignedTo : [],
            SelectedBuildingList : [],
            SelectedBuilding : [],
            SelectedTenantList : [],
            SelectedTenant : [],
            SelectedProblemList : [],
            SelectedProblem : [],
            IsSingleBuildingDeleted: false
        }
        this.DeleteStatus = this.DeleteStatus.bind(this);
        this.DeleteAssignedTo = this.DeleteAssignedTo.bind(this);
        this.DeleteBuilding = this.DeleteBuilding.bind(this);
        this.DeleteTenant = this.DeleteTenant.bind(this);
        this.DeleteProblem = this.DeleteProblem.bind(this);
        this.dropdown_fields = { text: 'value', value: 'id' };
    }

    OnSort(values) {
        if(values !== undefined && values !== null && values !== "--"){
            const sorted_data = values.sort((a, b) => {
                let nameA, nameB;
                nameA = a.orderId;
                nameB = b.orderId;
                return (nameA - nameB);
            });
            return sorted_data;
        }
    }

    onStatusSelect(args) { 
        var selectedStatusId = null;
        var l_SelectedStatus = this.state.SelectedStatusList;
        l_SelectedStatus.push(args.itemData);
        if(l_SelectedStatus !== undefined && l_SelectedStatus != null && l_SelectedStatus.length){
            selectedStatusId = l_SelectedStatus.map(el => ( el.id ));
        }
        this.setState({ SelectedStatusList : l_SelectedStatus, SelectedStatus : selectedStatusId });
        this.props.FilterSelection({"Type":"Status","Ids":l_SelectedStatus});
    }

    onStatusRemove(args){
        var selectedStatusId = null;
        var lSelectedStatus = this.state.SelectedStatusList;
        var FilteredData = lSelectedStatus.filter(x => x.id !== args.itemData.id);
        if(FilteredData !== undefined && FilteredData != null && FilteredData.length){
            selectedStatusId = FilteredData.map(el => ( el.id ));
        }
        this.setState({ SelectedStatusList : FilteredData, SelectedStatus : selectedStatusId });
        this.props.FilterSelection({"Type":"Status","Ids":FilteredData});
    }

    DeleteStatus(StatusId){ 
        var selectedStatusId = null;
        var lSelectedStatus = this.state.SelectedStatusList;
        var FilteredData = lSelectedStatus.filter(x => x.id !== StatusId);
        if(FilteredData !== undefined && FilteredData != null && FilteredData.length){
            selectedStatusId = FilteredData.map(el => ( el.id ));
        }
        this.setState({ SelectedStatusList : FilteredData, SelectedStatus : selectedStatusId });
        this.props.FilterSelection({"Type":"Status","Ids":FilteredData});
    }

    onAssignedToSelect(args) { 
        var selectedAssignedToId = null;
        var l_SelectedAssignedTo = this.state.SelectedAssignedToList;
        l_SelectedAssignedTo.push(args.itemData);
        if(l_SelectedAssignedTo !== undefined && l_SelectedAssignedTo != null && l_SelectedAssignedTo.length){
            selectedAssignedToId = l_SelectedAssignedTo.map(el => ( el.id ));
        }
        this.setState({ SelectedAssignedToList : l_SelectedAssignedTo, SelectedAssignedTo : selectedAssignedToId });
        this.props.FilterSelection({"Type":"AssignedTo","Ids":l_SelectedAssignedTo});
    }

    onAssignedToRemove(args){
        var selectedAssignedToId = null;
        var l_SelectedAssignedTo = this.state.SelectedAssignedToList;
        var FilteredData = l_SelectedAssignedTo.filter(x => x.id !== args.itemData.id);
        if(FilteredData !== undefined && FilteredData != null && FilteredData.length){
            selectedAssignedToId = FilteredData.map(el => ( el.id ));
        }
        this.setState({ SelectedAssignedToList : FilteredData, SelectedAssignedTo : selectedAssignedToId });
        this.props.FilterSelection({"Type":"AssignedTo","Ids":FilteredData});
    }

    DeleteAssignedTo(AssignedToId){ 
        var selectedAssignedToId = null;
        var l_SelectedAssignedTo = this.state.SelectedAssignedToList;
        var FilteredData = l_SelectedAssignedTo.filter(x => x.id !== AssignedToId);
        if(FilteredData !== undefined && FilteredData != null && FilteredData.length){
            selectedAssignedToId = FilteredData.map(el => ( el.id ));
        }
        this.setState({ SelectedAssignedToList : FilteredData, SelectedAssignedTo : selectedAssignedToId });
        this.props.FilterSelection({"Type":"AssignedTo","Ids":FilteredData});
    }

    onBuildingSelect(args) { 
        var selectedBuildingId = null;
        var l_SelectedBuilding = this.state.SelectedBuildingList;
        l_SelectedBuilding.push(args.itemData);
        if(l_SelectedBuilding !== undefined && l_SelectedBuilding != null && l_SelectedBuilding.length){
            selectedBuildingId = l_SelectedBuilding.map(el => ( el.id ));
        }
        this.setState({ SelectedBuildingList : l_SelectedBuilding, SelectedBuilding : selectedBuildingId, IsSingleBuildingDeleted: false });
        this.DeleteTenantByBuilding(l_SelectedBuilding);
        this.props.FilterSelection({"Type":"Building","Ids":l_SelectedBuilding});
    }

    onBuildingRemove(args){
        var selectedBuildingId = null;
        var l_SelectedBuilding = this.state.SelectedBuildingList;
        var FilteredData = l_SelectedBuilding.filter(x => x.id !== args.itemData.id);
        if(FilteredData !== undefined && FilteredData != null && FilteredData.length){
            selectedBuildingId = FilteredData.map(el => ( el.id ));
        }
        this.setState({ SelectedBuildingList : FilteredData, SelectedBuilding : selectedBuildingId });
        this.DeleteTenantByBuilding(FilteredData);
        this.props.FilterSelection({"Type":"Building","Ids":FilteredData});
    }

    DeleteBuilding(BuildingId){ 
        var selectedBuildingId = null;
        var l_SelectedBuilding = this.state.SelectedBuildingList;
        var FilteredData = l_SelectedBuilding.filter(x => x.id !== BuildingId);
        if(FilteredData !== undefined && FilteredData != null && FilteredData.length){
            selectedBuildingId = FilteredData.map(el => ( el.id ));
        }
        this.setState({ SelectedBuildingList : FilteredData, SelectedBuilding : selectedBuildingId });
        this.DeleteTenantByBuilding(FilteredData);
        this.props.FilterSelection({"Type":"Building","Ids":FilteredData});
    }

    DeleteTenantByBuilding(SelectedBuildingList){
        var selectedTenantId = null;
        var l_SelectedTenant = this.state.SelectedTenantList;
        var FilteredData = [];

        SelectedBuildingList.forEach(el => {
            l_SelectedTenant.forEach(element => {
                if(element.buildings != null) {   
                    var l_Tenant = element.buildings.filter(x => x.buildingId === el.id);              
                    if (l_Tenant.length > 0 && FilteredData.filter(x => x.id === element.id).length <= 0) {
                        FilteredData.push({ "id" : element.id, "value" : element.value, "buildings" : element.buildings });
                    }
                }
            });
        });

        if(FilteredData !== undefined && FilteredData != null && FilteredData.length){
            selectedTenantId = FilteredData.map(el => ( el.id ));
        }
        this.setState({ SelectedTenantList : FilteredData, SelectedTenant : selectedTenantId });
        this.props.FilterSelection({"Type":"Tenant","Ids":FilteredData});
    }

    onTenantSelect(args) { 
        var selectedTenantId = null;
        var l_SelectedTenant = this.state.SelectedTenantList;
        l_SelectedTenant.push(args.itemData);
        if(l_SelectedTenant !== undefined && l_SelectedTenant != null && l_SelectedTenant.length){
            selectedTenantId = l_SelectedTenant.map(el => ( el.id ));
        }
        this.setState({ SelectedTenantList : l_SelectedTenant, SelectedTenant : selectedTenantId });
        this.props.FilterSelection({"Type":"Tenant","Ids":l_SelectedTenant});
    }

    onTenantRemove(args){
        var selectedTenantId = null;
        var l_SelectedTenant = this.state.SelectedTenantList;
        var FilteredData = l_SelectedTenant.filter(x => x.id !== args.itemData.id);
        if(FilteredData !== undefined && FilteredData != null && FilteredData.length){
            selectedTenantId = FilteredData.map(el => ( el.id ));
        }
        this.setState({ SelectedTenantList : FilteredData, SelectedTenant : selectedTenantId });
        this.props.FilterSelection({"Type":"Tenant","Ids":FilteredData});
    }

    DeleteTenant(TenantId){ 
        var selectedTenantId = null;
        var l_SelectedTenant = this.state.SelectedTenantList;
        var FilteredData = l_SelectedTenant.filter(x => x.id !== TenantId);
        if(FilteredData !== undefined && FilteredData != null && FilteredData.length){
            selectedTenantId = FilteredData.map(el => ( el.id ));
        }
        this.setState({ SelectedTenantList : FilteredData, SelectedTenant : selectedTenantId });
        this.props.FilterSelection({"Type":"Tenant","Ids":FilteredData});
    }

    onProblemSelect(args) { 
        var selectedProblemId = null;
        var l_SelectedProblem = this.state.SelectedProblemList;
        l_SelectedProblem.push(args.itemData);
        if(l_SelectedProblem !== undefined && l_SelectedProblem != null && l_SelectedProblem.length){
            selectedProblemId = l_SelectedProblem.map(el => ( el.id ));
        }
        this.setState({ SelectedProblemList : l_SelectedProblem, SelectedProblem : selectedProblemId });
        this.props.FilterSelection({"Type":"Problem","Ids":l_SelectedProblem});
    }

    onProblemRemove(args){
        var selectedProblemId = null;
        var l_SelectedProblem = this.state.SelectedProblemList;
        var FilteredData = l_SelectedProblem.filter(x => x.id !== args.itemData.id);
        if(FilteredData !== undefined && FilteredData != null && FilteredData.length){
            selectedProblemId = FilteredData.map(el => ( el.id ));
        }
        this.setState({ SelectedProblemList : FilteredData, SelectedProblem : selectedProblemId });
        this.props.FilterSelection({"Type":"Problem","Ids":FilteredData});
    }

    DeleteProblem(ProblemId){ 
        var selectedProblemId = null;
        var l_SelectedProblem = this.state.SelectedProblemList;
        var FilteredData = l_SelectedProblem.filter(x => x.id !== ProblemId);
        if(FilteredData !== undefined && FilteredData != null && FilteredData.length){
            selectedProblemId = FilteredData.map(el => ( el.id ));
        }
        this.setState({ SelectedProblemList : FilteredData, SelectedProblem : selectedProblemId });
        this.props.FilterSelection({"Type":"Problem","Ids":FilteredData});
    }

    render() {
        let label = this.props.getLabels;
        let preferredfields = this.props.getWorkorderPreferences;
        var Status_in_Select_input = [], Assigned_in_Select_input = [], Building_in_Select_input = [], Tenant_in_Select_input = [], Problem_in_Select_input = [];
        var StatusList = [], AssignedToList = [], BuildingList = [], TenantList = [], ProblemList = [];
        var BuildingsList = [];
        var DropdownClass = this.state.IsSingleBuildingDeleted ? "customerrorhighlight" : "WO_Filter_Multi_Ddl"; 
        
        var status = (preferredfields !== ""  && preferredfields !== undefined) ? preferredfields.filter(x => x.field === "Status" && x.display === true) : "";
        var assignedto = (preferredfields !== ""  && preferredfields !== undefined) ? preferredfields.filter(x => x.field === "Assigned To" && x.display === true) : "";
        var building = (preferredfields !== ""  && preferredfields !== undefined) ? preferredfields.filter(x => x.field === "Building" && x.display === true) : "";
        var tenant = (preferredfields !== ""  && preferredfields !== undefined) ? preferredfields.filter(x => x.field === "Tenant" && x.display === true) : "";
        var problem = (preferredfields !== ""  && preferredfields !== undefined) ? preferredfields.filter(x => x.field === "Problem" && x.display === true) : "";

        //Status
        var Status = label['WorkOrders.Status.Text'] !== undefined ? label['WorkOrders.Status.Text'].split(',') : [];
        if (status.length > 0) {
            if (status[0].value.length > 0) {
                var status_values = this.OnSort(status[0].value);
                status_values.forEach(el => {
                    Status_in_Select_input.push({ "id" : el.key, "value" : el.value });
                });
            }
        }else {
            Status.forEach(el => {
                Status_in_Select_input.push({ "id" : el, "value" : label['WorkOrders.Status.' + el + '.Text'] });
            });
        }
        if (this.state.SelectedStatusList !== undefined && this.state.SelectedStatusList !== null && this.state.SelectedStatusList.length) {
            var lstStatus = this.state.SelectedStatusList;
            const rows = [...Array( Math.ceil(lstStatus.length / 3) )];
            // chunk the products into the array of rows
            const productRows = rows.map( (row, idx) => lstStatus.slice(idx * 3, idx * 3 + 3) );
            // map the rows as div.row
            StatusList = productRows.map((row, idx) => (
                <div className="row" key={idx}>    
                  {/* map products in the row as article.col-md-3 */}
                  { row.map( product => <div key={product.id} className="col-md-2">
                    <div><FaTrashAlt style={{ color:"#676767", float:"left" }} className="Ensemble_Icon link_cursor" onClick={() => { this.DeleteStatus(product.id) }} /><label className="reportsFilterlbl">{product.value}</label></div>
                  </div> )}
                </div> 
            ));
        } 

        //AssignedTo
        if (this.props.getTechnicianList !== undefined && this.props.getTechnicianList !== null && this.props.getTechnicianList.length) {
            this.props.getTechnicianList.sort((a,b) => (a.name.toLowerCase() > b.name.toLowerCase()) - (a.name.toLowerCase() < b.name.toLowerCase())).forEach(el => {
                Assigned_in_Select_input.push({ "id" : el.technicianID, "value" : el.name });
            });
        }
        if (this.state.SelectedAssignedToList !== undefined && this.state.SelectedAssignedToList !== null && this.state.SelectedAssignedToList.length) {
            var lstData4 = this.state.SelectedAssignedToList;
            const rows = [...Array( Math.ceil(lstData4.length / 3) )];
            // chunk the products into the array of rows
            const productRows = rows.map( (row, idx) => lstData4.slice(idx * 3, idx * 3 + 3) );
            // map the rows as div.row
            AssignedToList = productRows.map((row, idx) => (
                <div className="row" key={idx}>    
                  {/* map products in the row as article.col-md-3 */}
                  { row.map( product => <div key={product.id} className="col-md-2">
                    <div><label className="reportsFilterlbl">{product.value}</label><FaTrashAlt style={{ color:"#676767", float:"left" }} className="Ensemble_Icon link_cursor" onClick={() => { this.DeleteAssignedTo(product.id) }} /></div>
                  </div> )}
                </div> 
            ));
        }

        //Building
        if (this.props.getWorkOrderBuildings !== undefined && this.props.getWorkOrderBuildings !== null && this.props.getWorkOrderBuildings.length > 0)
            BuildingsList = this.props.getWorkOrderBuildings.filter(el => el.isDeleted === false);
        if (BuildingsList !== undefined && BuildingsList !== null && BuildingsList.length > 0) {
            BuildingsList.sort((a,b) => (a.name.toLowerCase() > b.name.toLowerCase()) - (a.name.toLowerCase() < b.name.toLowerCase())).forEach(el => {
                Building_in_Select_input.push({ "id" : el.id, "value" : el.name });
            });
        }
        if (this.state.SelectedBuildingList !== undefined && this.state.SelectedBuildingList !== null && this.state.SelectedBuildingList.length) {
            var lstData3 = this.state.SelectedBuildingList;
            const rows = [...Array( Math.ceil(lstData3.length / 3) )];
            const productRows = rows.map( (row, idx) => lstData3.slice(idx * 3, idx * 3 + 3) );
            BuildingList = productRows.map((row, idx) => (
                <div className="row" key={idx}>    
                  { row.map( product => <div key={product.id} className="col-md-2">
                    <div><label className="reportsFilterlbl">{product.value}</label><FaTrashAlt style={{ color:"#676767", float:"left" }} className="Ensemble_Icon link_cursor" onClick={() => { this.DeleteBuilding(product.id) }} /></div>
                  </div> )}
                </div> 
            ));
        }

        //Tenants
        if (this.props.getTenantList !== undefined && this.props.getTenantList !== null && this.props.getTenantList.length) {
            if(this.state.SelectedBuildingList !== undefined && this.state.SelectedBuildingList !== null && this.state.SelectedBuildingList.length){
                var selectedBuildinglst = [...this.state.SelectedBuildingList];
                selectedBuildinglst.sort((a,b) => (a.value.toLowerCase() > b.value.toLowerCase()) - (a.value.toLowerCase() < b.value.toLowerCase())).forEach(ele => {
                    this.props.getTenantList.sort((a,b) => (a.tenantName.toLowerCase() > b.tenantName.toLowerCase()) - (a.tenantName.toLowerCase() < b.tenantName.toLowerCase())).forEach(element => {
                        if(element.buildings != null) {  
                            var l_Tenants = element.buildings.filter(x => x.buildingId === ele.id);
                            if(l_Tenants.length > 0 && Tenant_in_Select_input.filter(x => x.id === element.tenantId).length <= 0){
                                Tenant_in_Select_input.push({ "id" : element.tenantId, "value" : element.tenantName, "buildings" : element.buildings });
                            }
                        }
                    });
                });
            }else{
                this.props.getTenantList.sort((a,b) => (a.tenantName.toLowerCase() > b.tenantName.toLowerCase()) - (a.tenantName.toLowerCase() < b.tenantName.toLowerCase())).forEach((el) => {
                    Tenant_in_Select_input.push({ "id" : el.tenantId, "value" : el.tenantName, "buildings" : el.buildings });
                });
            }
        }
        if (this.state.SelectedTenantList !== undefined && this.state.SelectedTenantList !== null && this.state.SelectedTenantList.length) {
            var lstData2 = this.state.SelectedTenantList;
            const rows = [...Array( Math.ceil(lstData2.length / 3) )];
            const productRows = rows.map( (row, idx) => lstData2.slice(idx * 3, idx * 3 + 3) );
            TenantList = productRows.map((row, idx) => (
                <div className="row" key={idx}>    
                  { row.map( product => <div key={product.id} className="col-md-2">
                    <div><label className="reportsFilterlbl">{product.value}</label><FaTrashAlt style={{ color:"#676767", float:"left" }} className="Ensemble_Icon link_cursor" onClick={() => { this.DeleteTenant(product.id) }} /></div>
                  </div> )}
                </div> 
            ));
        }

        //Problems
        var Problems = label['WorkOrders.Problem.Text'] !== undefined ? label['WorkOrders.Problem.Text'].split(',') : [];
        if (problem.length > 0) {
            if (problem[0].value.length > 0) {
                var problem_values = this.OnSort(problem[0].value);
                problem_values.forEach(el => {
                    Problem_in_Select_input.push({ "id" : el.key, "value" : el.value });
                });
            }
        }else {
            Problems.forEach(el => {
                Problem_in_Select_input.push({ "id" : el, "value" : label['WorkOrders.Problem.' + el + '.Text'] });
            });
        }
        if (this.state.SelectedProblemList !== undefined && this.state.SelectedProblemList !== null && this.state.SelectedProblemList.length) {
            var lstData1 = this.state.SelectedProblemList;
            const rows = [...Array( Math.ceil(lstData1.length / 2) )];
            const productRows = rows.map( (row, idx) => lstData1.slice(idx * 2, idx * 2 + 2) );
            ProblemList = productRows.map((row, idx) => (
                <div className="row" key={idx}>    
                  { row.map( product => <div key={product.id} className="col-md-4">
                    <div><label className="reportsFilterlbl">{product.value}</label><FaTrashAlt style={{ color:"#676767", float:"left" }} className="Ensemble_Icon link_cursor" onClick={() => { this.DeleteProblem(product.id) }} /></div>
                  </div> )}
                </div> 
            ));
        }

        return (
            <div>
                <Form>
                    <FormGroup row>
                        <Col sm={{ size: 12 }}>
                            <Label id="label_filters" className="reportsHeaderlbl">Filters</Label>
                        </Col>
                    </FormGroup>
                    <FormGroup row style={{marginBottom: "0px"}}>
                        <Col sm={{ size: 6 }}>
                            <Label id="label_status" style={{ marginBottom: "0px" }} className="workorderlbl">{status.length > 0 ? status[0].fieldLabel : "Status"}</Label><br />
                            <MultiSelectComponent id="select_status" ref='status_in_Select_input' width='100%' cssClass="WO_Filter_Multi_Ddl"
                                dataSource={Status_in_Select_input}  
                                select={this.onStatusSelect.bind(this)}
                                removed={this.onStatusRemove.bind(this)}
                                fields={this.dropdown_fields} 
                                value={this.state.SelectedStatus}
                                mode="CheckBox" 
                                showDropDownIcon={true} showSelectAll={true} enableSelectionOrder={false} 
                                filterBarPlaceholder="Search" placeholder="-Select-" selectAllText="Select All" unSelectAllText="Clear All" >
                                <Inject services={[CheckBoxSelection]} />
                            </MultiSelectComponent>
                        </Col>
                    </FormGroup>
                    <FormGroup row style={{marginBottom: "20px"}}>
                        <Col sm={{ size: 12 }}>
                            {StatusList}
                        </Col>
                    </FormGroup>
                    <FormGroup row style={{marginBottom: "0px"}}>
                        <Col sm={{ size: 6 }}>
                            <Label id="label_assignedto" style={{ marginBottom: "0px" }} className="workorderlbl">{assignedto.length > 0 ? assignedto[0].fieldLabel : "Assigned To"}</Label><br />
                            <MultiSelectComponent id="select_assignedto" ref='assigned_in_Select_input' width='100%' cssClass="WO_Filter_Multi_Ddl"
                                dataSource={Assigned_in_Select_input}  
                                select={this.onAssignedToSelect.bind(this)}
                                removed={this.onAssignedToRemove.bind(this)}
                                fields={this.dropdown_fields} 
                                value={this.state.SelectedAssignedTo}
                                mode="CheckBox" 
                                showDropDownIcon={true} showSelectAll={true} enableSelectionOrder={false} 
                                filterBarPlaceholder="Search" placeholder="-Select-" selectAllText="Select All" unSelectAllText="Clear All" >
                                <Inject services={[CheckBoxSelection]} />
                            </MultiSelectComponent>
                        </Col>
                    </FormGroup>
                    <FormGroup row style={{marginBottom: "20px"}}>
                        <Col sm={{ size: 12 }}>
                            {AssignedToList}
                        </Col>
                    </FormGroup>
                    <FormGroup row style={{marginBottom: "0px"}}>
                        <Col sm={{ size: 6 }}>
                            <Label id="label_buildings" style={{ marginBottom: "0px" }} className="workorderlbl">{building.length > 0 ? building[0].fieldLabel : "Buildings"}</Label><br />
                            <MultiSelectComponent id="select_buildings" ref='building_in_Select_input' width='100%' cssClass={DropdownClass}
                                dataSource={Building_in_Select_input}  
                                select={this.onBuildingSelect.bind(this)}
                                removed={this.onBuildingRemove.bind(this)}
                                fields={this.dropdown_fields} 
                                value={this.state.SelectedBuilding}
                                mode="CheckBox"
                                showDropDownIcon={true} showSelectAll={true} enableSelectionOrder={false} 
                                filterBarPlaceholder="Search" placeholder="-Select-" selectAllText="Select All" unSelectAllText="Clear All" >
                                <Inject services={[CheckBoxSelection]} />
                            </MultiSelectComponent>
                            <span hidden={!this.state.IsSingleBuildingDeleted}><Label style={{'color':'#D42D27', 'font-style':'italic','font-size':'10px','font-family':'Lato' }}><b>Selected building(s) no longer in system</b></Label></span>
                        </Col>
                    </FormGroup>
                    <FormGroup row style={{marginBottom: "20px"}}>
                        <Col sm={{ size: 12 }}>
                            {BuildingList}
                        </Col>
                    </FormGroup>
                    <FormGroup row style={{marginBottom: "0px"}}>
                        <Col sm={{ size: 6 }}>
                            <Label id="label_tenants" style={{ marginBottom: "0px" }} className="workorderlbl">{tenant.length > 0 ? tenant[0].fieldLabel : "Tenants"}</Label><br />
                            <MultiSelectComponent id="select_tenants" ref='tenant_in_Select_input' width='100%' cssClass="WO_Filter_Multi_Ddl"
                                dataSource={Tenant_in_Select_input}  
                                select={this.onTenantSelect.bind(this)}
                                removed={this.onTenantRemove.bind(this)}
                                fields={this.dropdown_fields} 
                                value={this.state.SelectedTenant}
                                mode="CheckBox" 
                                showDropDownIcon={true} showSelectAll={true} enableSelectionOrder={false} 
                                filterBarPlaceholder="Search" placeholder="-Select-" selectAllText="Select All" unSelectAllText="Clear All" >
                                <Inject services={[CheckBoxSelection]} />
                            </MultiSelectComponent>
                        </Col>
                    </FormGroup>
                    <FormGroup row style={{marginBottom: "20px"}}>
                        <Col sm={{ size: 12 }}>
                            {TenantList}
                        </Col>
                    </FormGroup>
                    <FormGroup row style={{marginBottom: "0px"}}>
                        <Col sm={{ size: 6 }}>
                            <Label id="label_problem" style={{ marginBottom: "0px" }} className="workorderlbl">{problem.length > 0 ? problem[0].fieldLabel : "Problem"}</Label><br />
                            <MultiSelectComponent id="select_problem" ref='problem_in_Select_input' width='100%' cssClass="WO_Filter_Multi_Ddl"
                                dataSource={Problem_in_Select_input} 
                                select={this.onProblemSelect.bind(this)}
                                removed={this.onProblemRemove.bind(this)} 
                                fields={this.dropdown_fields} 
                                value={this.state.SelectedProblem}
                                mode="CheckBox" 
                                showDropDownIcon={true} showSelectAll={true} enableSelectionOrder={false} 
                                filterBarPlaceholder="Search" placeholder="-Select-" selectAllText="Select All" unSelectAllText="Clear All" >
                                <Inject services={[CheckBoxSelection]} />
                            </MultiSelectComponent>
                        </Col>
                    </FormGroup>
                    <FormGroup row style={{marginBottom: "20px"}}>
                        <Col sm={{ size: 12 }}>
                            {ProblemList}
                        </Col>
                    </FormGroup>
                </Form>
            </div>
        )
    };
};

const mapStateToProps = (state) => {
    return {
        getLabels: state.CulturalLabelsRootReducer.WorkOrderResource_LabelsBasedOnPreference,
        getWorkorderPreferences: state.authService.workorder_user_preferencedetails,
        getTechnicianList: state.WorkorderRootReducer.Technicians,
        getWorkOrderBuildings: state.WorkorderRootReducer.WorkorderBuildings,
        getTenantList: state.tenantsRootReducer.TenantsList,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        makeGetCall: () => dispatch(makeGetCall()),
        GetWorkOrderBuildingsList: () => dispatch(GetWorkOrderBuildingsList()),
        GetWorkorderTechnician: () => dispatch(GetWorkorderTechnician())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WOReportFilter);